export const isUuid = (value?: string): boolean => {
  if (!value) {
    return false;
  }

  return /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(
    value,
  );
};
